module.exports = __webpack_public_path__ + "static/assets/Mercator.8ac36490.png";